import React from 'react';
import SkeletonArticle from './SkeletonArticle';

const SkeletonList: React.FC = () => {
  return (
    <>
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
      <SkeletonArticle />
    </>
  );
};

export default SkeletonList;
